import React, {useEffect, useState, useCallback} from "react";
import {createUseStyles, useTheme} from "react-jss";
import TabNav from "../../../../../../artibulles-cis/TabNav/TabNav";

import InvoiceEditDetails from "./InvoiceEditDetails";
import InvoiceTableAll from "./InvoiceTableAll";
import InvoicesTableBySupplier from "./InvoicesTableBySupplier";
import InvoicesTableByImportedTransactions from "./InvoicesTableByImportedTransactions";

//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    ClassExtendTabNavLink: {
        borderRight: "1px solid rgb(220 220 220)",
    },
}));

const CustomerRouter = React.memo(function CustomerRouter(props) {
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** REFS ******************/

    /***************** REFS ******************/

    /***************** CONST ******************/

    /***************** CONST ******************/

    /***************** STATE ******************/

    /***************** STATE ******************/

    /***************** CALLBACK ******************/

    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/

    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/

    return (
        <TabNav
            MainSlug={`/financials/saleordersandinvoices/invoices/list`}
            DefaultTab={`/financials/saleordersandinvoices/invoices/list/all`}
            ClassExtendTabNavLink={classes.ClassExtendTabNavLink}
            ActiveIndicator={{
                WithIndicator: true,
                Position: "Bottom",
            }}
            TabMenuContent={[
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>All invoices</div>
                        </div>
                    ),
                    Slug: `/financials/saleordersandinvoices/invoices/list/all`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <InvoiceTableAll />,
                },
                {
                    TabMenu: (
						
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Unpaid Invoices</div>
                        </div>
                    ),
                    Slug: `/financials/saleordersandinvoices/invoices/list/opened`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <InvoiceEditDetails />,
                },
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Invoices by supplier</div>
                        </div>
                    ),
                    Slug: `/financials/saleordersandinvoices/invoices/list/bysupplier`,
					exact : true,
                    ShowOnlyIfActive: false,
                    TabContent: <InvoicesTableBySupplier />,
                },
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Imported Invoices</div>
                        </div>
                    ),
                    Slug: `/financials/saleordersandinvoices/invoices/list/byimportedtransactions`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <InvoicesTableByImportedTransactions />,
                },
				{
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Purchase Orders</div>
                        </div>
                    ),
                    Slug: `/financials/saleordersandinvoices/invoices/list/purchaseorders`,
                    ShowOnlyIfActive: false,
					exact : true,
                    TabContent: <InvoiceEditDetails />,
                },
            ]}
        />
    );

    /***************** RENDER ******************/
});

export default CustomerRouter;
